export default "__VITE_ASSET__BRb1WRpl__"